// src/components/common/userform/TablePresetPicker.jsx
import React from "react";
import { TABLE_PRESETS } from "./tablePresets";

export default function TablePresetPicker({
  formType = "PS",
  onSelect,
  onClose,
}) {
  const ft = String(formType || "").toUpperCase();

  // tablePresets.js가 "스키마ID: { form, label, columns }" 형태이므로
  // form === 현재 폼타입 or form === null(공용) 만 필터링
  const entries = Object.entries(TABLE_PRESETS || {});
  const presets = entries
    .map(([schemaId, preset]) => ({ schemaId, preset }))
    .filter(({ preset }) => {
      const f = preset?.form ?? null;
      return f === null || String(f).toUpperCase() === ft;
    });

  const handleSelect = (schemaId, preset) => {
    if (typeof onSelect === "function") onSelect({ schemaId, preset });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
        role="button"
        aria-label="close"
      />
      {/* Dialog */}
      <div className="relative z-10 w-[720px] max-w-[90vw] rounded-2xl border bg-white shadow-xl">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <div className="text-base font-semibold">
            표 프리셋 선택 <span className="text-slate-500">/ {ft}</span>
          </div>
          <button
            className="rounded-lg border px-3 py-1.5 text-sm hover:bg-gray-50"
            onClick={onClose}
          >
            닫기
          </button>
        </div>

        <div className="max-h-[70vh] overflow-auto p-4">
          {presets.length === 0 ? (
            <div className="rounded-lg border bg-amber-50 p-4 text-sm text-amber-700">
              사용 가능한 프리셋이 없습니다.
              <div className="mt-1 text-xs text-amber-800">
                (formType = {ft}, presets keys ={" "}
                {Object.keys(TABLE_PRESETS || {}).join(", ") || "-"})
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-3">
              {presets.map(({ schemaId, preset }) => (
                <div
                  key={schemaId}
                  className="rounded-xl border bg-white p-3 hover:shadow-sm"
                >
                  <div className="mb-2 flex items-center justify-between">
                    <div>
                      <div className="text-sm font-medium">{preset.label}</div>
                      <div className="mt-0.5 text-xs text-slate-500">
                        스키마: <b>{schemaId}</b>{" "}
                        {preset.form ? (
                          <span className="ml-1">/ 폼: {preset.form}</span>
                        ) : (
                          <span className="ml-1">/ 공용</span>
                        )}
                        {preset.role ? (
                          <span> / 역할: {preset.role}</span>
                        ) : null}
                      </div>
                    </div>
                    <button
                      className="rounded-lg border px-3 py-1.5 text-sm hover:bg-gray-50"
                      onClick={() => handleSelect(schemaId, preset)}
                    >
                      선택
                    </button>
                  </div>

                  {/* 컬럼 미리보기 */}
                  <div className="overflow-x-auto rounded-lg border">
                    <table className="min-w-full text-sm">
                      <thead className="bg-gray-50 text-gray-600">
                        <tr>
                          {(preset.columns || []).map((c) => (
                            <th key={c.key} className="px-2 py-2 text-left">
                              {c.label}{" "}
                              <span className="text-xs text-slate-400">
                                ({c.type})
                              </span>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {(preset.columns || []).map((c) => (
                            <td
                              key={c.key}
                              className="px-2 py-2 text-slate-400"
                            >
                              …
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
